import { useListProductsQuery } from "api/memberPortal/product/product.api";

import ProductsInFinalReviewTable from "./ProductsInFinalReviewTable.table";

export const ProductsInFinalReviewTableContainer = () => {
  const { data: products, isFetching: isFetchingProducts } =
    useListProductsQuery({
      vendor_checkout_signature: "false",
      cctl_checkout_signature: "true",
      limit: 200,
    });

  return (
    <ProductsInFinalReviewTable
      products={products}
      isLoading={isFetchingProducts}
    />
  );
};

export default ProductsInFinalReviewTableContainer;
